import {
  PROJECT_FIELDS,
  RECURRING_FIELDS,
  TASK_FIELDS,
} from "@/modules/tasks/fields";
import { Recurring } from "@/modules/tasks/screens/Recurring";
import { Projects } from "@/modules/tasks/screens/Projects";
import { TaskBoard } from "@/modules/tasks/screens/TaskBoard";
import { taskList } from "@/modules/tasks/screens/TaskList";
import type { ModuleUi } from "@/modules/types";

/**
 * The Tasks module.
 *
 * `mine`, `board` and `all` all render tasks and share `TASK_FIELDS` — the
 * same "one vocabulary, several sections" shape `ordersModule` uses for
 * Orders' `all`/`unfulfilled`. `projects` renders a different row (a
 * `Project`) with its own vocabulary, the way Contacts' `types` section
 * does for `ContactType`.
 */
export const tasksModule: ModuleUi = {
  id: "tasks",
  sections: {
    mine: { fields: TASK_FIELDS, screen: taskList("mine") },
    board: {
      fields: TASK_FIELDS,
      screen: TaskBoard,
      nothingYet: { title: "No tasks yet" },
    },
    all: {
      fields: TASK_FIELDS,
      screen: taskList(),
      commonFilters: ["status", "assigneeUserId", "priority", "dueDate"],
      count: async (data, query) =>
        (await data.tasks.list({ ...query, limit: 1 })).total,
    },
    recurring: {
      fields: RECURRING_FIELDS,
      screen: Recurring,
      nothingYet: {
        title: "No recurring tasks yet",
        description:
          "Make one for the jobs that come round every week or month, and a new task appears each time.",
      },
    },
    projects: { fields: PROJECT_FIELDS, screen: Projects },
  },
};
